export default "assets/images/palate-2c3ddb7f.svg";